/**
 * cart-progress-bar.js — Dog Theme Cart Progress Bar
 * Zero state management. Liquid renders everything server-side.
 * JS does nothing — the fill width is set inline by Liquid.
 * This file is intentionally minimal and can be removed entirely
 * if you have no need for theme editor re-init.
 */
(function () {
  // Re-init on theme editor section load only
  document.addEventListener('shopify:section:load', function () {
    // Nothing to do — Liquid has already rendered the correct state
  });
})();